import { useMemo } from "react";

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
const BASE_MINUTES = ["00", "15", "30", "45"];

/** Selector de hora en 24hs con dos <select> (hora + minutos), para no depender
 * del picker nativo del sistema operativo (Android con reloj 12hs abre el
 * selector AM/PM que no sirve para turnos 19:00-07:00 y se corta en pantalla
 * chica). El valor se sigue guardando/leyendo como texto "HH:MM" en 24hs. */
export function Time24Select({ value, onChange, disabled = false, required = false, testId, style }) {
  const [h, m] = (value || "").split(":");
  const hour = h || "";
  const minute = m || "";

  const minuteOptions = useMemo(() => {
    if (minute && !BASE_MINUTES.includes(minute)) return [...BASE_MINUTES, minute].sort();
    return BASE_MINUTES;
  }, [minute]);

  const setHour = (newHour) => {
    if (!newHour) { onChange(""); return; }
    onChange(`${newHour}:${minute || "00"}`);
  };
  const setMinute = (newMinute) => {
    if (!newMinute) { onChange(""); return; }
    onChange(`${hour || "00"}:${newMinute}`);
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
      <select disabled={disabled} required={required} value={hour} onChange={(e) => setHour(e.target.value)}
        data-testid={testId ? `${testId}-hour` : undefined} style={{ flex: 1, minWidth: 0, ...style }}>
        <option value="">Hs</option>
        {HOURS.map((hh) => <option key={hh} value={hh}>{hh}</option>)}
      </select>
      <span style={{ fontWeight: 800, color: "var(--invict-text-muted)" }}>:</span>
      <select disabled={disabled} required={required} value={minute} onChange={(e) => setMinute(e.target.value)}
        data-testid={testId ? `${testId}-minute` : undefined} style={{ flex: 1, minWidth: 0, ...style }}>
        <option value="">Min</option>
        {minuteOptions.map((mm) => <option key={mm} value={mm}>{mm}</option>)}
      </select>
    </div>
  );
}
